(function () {
    'use strict';

    const exportButtons = [
        {
            extend: 'copyHtml5',
            text: '<i class="bi bi-clipboard me-1"></i>Copy',
            exportOptions: {
                columns: ':not(:last-child)'
            }
        },
        {
            extend: 'csvHtml5',
            text: '<i class="bi bi-filetype-csv me-1"></i>CSV',
            exportOptions: {
                columns: ':not(:last-child)'
            }
        },
        {
            extend: 'excelHtml5',
            text: '<i class="bi bi-file-earmark-excel me-1"></i>Excel',
            exportOptions: {
                columns: ':not(:last-child)'
            }
        },
        {
            extend: 'pdfHtml5',
            text: '<i class="bi bi-file-earmark-pdf me-1"></i>PDF',
            exportOptions: {
                columns: ':not(:last-child)'
            },
            orientation: 'landscape',
            pageSize: 'A4'
        },
        {
            extend: 'print',
            text: '<i class="bi bi-printer me-1"></i>Print',
            exportOptions: {
                columns: ':not(:last-child)'
            }
        }
    ];

    function initCustomsTable(selector, options) {
        const tableElement = document.querySelector(selector);
        if (!tableElement) {
            return;
        }

        const actionColumn = tableElement.dataset.actionColumn;
        const columnDefs = [];
        if (actionColumn === 'last') {
            columnDefs.push({ orderable: false, targets: [-1] });
        }

        new DataTable(selector, {
            pageLength: Number(tableElement.dataset.pageLength || 25),
            order: options.order || [[0, 'asc']],
            responsive: false,
            autoWidth: false,
            columnDefs: columnDefs,
            layout: {
                topStart: {
                    buttons: [
                        {
                            extend: 'collection',
                            text: '<i class="bi bi-download me-1"></i>Export',
                            attr: {class: 'btn btn-sm btn-outline-secondary'},
                            buttons: exportButtons
                        },
                        {
                            extend: 'colvis',
                            text: '<i class="bi bi-layout-three-columns me-1"></i>Columns',
                            attr: {class: 'btn btn-sm btn-outline-secondary'}
                        }
                    ]
                },
                topEnd: {
                    search: {
                        placeholder: tableElement.dataset.searchPlaceholder || 'Search'
                    }
                },
                bottomStart: 'info',
                bottomEnd: 'paging'
            }
        });
    }

    function bindProductCodeLookup() {
        document.querySelectorAll('.customs-product-code-input, [data-product-code-lookup]').forEach(function (lookup) {
            lookup.addEventListener('input', function () {
                const list = document.getElementById(lookup.getAttribute('list'));
                const option = list
                    ? Array.from(list.options).find(function (candidate) {
                        return candidate.value === lookup.value || candidate.dataset.code === lookup.value;
                    })
                    : null;
                if (!option) {
                    return;
                }

                const form = lookup.closest('form');
                if (!form) {
                    return;
                }

                const productCode = form.querySelector('[name="product_code"]');
                const invoiceDescription = form.querySelector('[name="invoice_description"]');
                const tariffDescription = form.querySelector('[name="tariff_description"]');
                const tariffCode = form.querySelector('[name="tariff_code"]');
                if (productCode) {
                    productCode.value = option.dataset.code || lookup.value;
                }
                if (invoiceDescription && !invoiceDescription.value) {
                    invoiceDescription.value = option.dataset.description || option.dataset.tariffDescription || '';
                }
                if (tariffDescription && !tariffDescription.value) {
                    tariffDescription.value = option.dataset.tariff || option.dataset.tariffDescription || option.dataset.description || '';
                }
                if (tariffCode && !tariffCode.value) {
                    tariffCode.value = option.dataset.tariffCode || '';
                }
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initCustomsTable('#customsBatchesTable', { order: [[4, 'desc']] });
        initCustomsTable('#customsProductCodesTable', { order: [[1, 'asc']] });
        initCustomsTable('#customsReviewPagesTable', { order: [[0, 'asc'], [1, 'asc']] });
        initCustomsTable('#customsInvoicesTable', { order: [[4, 'asc'], [0, 'asc']] });
        initCustomsTable('#customsSummaryPreviewTable', { order: [[0, 'asc']] });
        initCustomsTable('#customsInvoiceLinesTable', { order: [[0, 'asc'], [1, 'asc']] });
        initCustomsTable('#workflowTable', { order: [[1, 'asc']] });
        bindProductCodeLookup();
    });
})();
